import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/user/loginReducer";
import { CamelCaseToFirstUpper } from "../Functions/word.fun";
import { useNavigate } from "react-router";
import LoginTimeCounter from "./login_time_counter";
import { FcEngineering, FcLock, FcSportsMode } from "react-icons/fc";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import GoogleTranslate from "../../CustomComponent/GoogleTranslate";
import Sidebarnew from "./side_barnew";
import { Toast } from "../../CustomComponent/toast";
// import { fetchTaskCounts } from "../../redux/task/taskReducer";
import { fetchTaskCounts } from "../../redux/Task/taskReducer";

const HeaderMenu = () => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const { totalTask, totalCompleteTask } = useSelector((state) => state.task);
  const loginState = useSelector((store) => store.login);
  const [loginTime, setLoginTime] = useState();
  const dispatch = useDispatch();
  const [salesOwnerSummary, setSalesOwnerSummary] = useState();
  const [employee, setEmployee] = useState(
    store &&
      (store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
        store.Role === process.env.REACT_APP_ROLE_ADMIN)
      ? "all"
      : store.Name
  );
  const [revenue, setRevenue] = useState();

  // const [totalTask, setTotalTask] = useState(0);
  // const [totalCompleteTask, setTotalCompleteTask] = useState(0);

  const getDateTime = (date) => {
    const formattedDate = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;

    return formattedDate;
  };
  useEffect(() => {
    if (
      store.UserId &&
      (store.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
        store.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
        store.Role === process.env.REACT_APP_ROLE_SALLE)
    ) {
      performRequest("GET", `/allTablesCount/getLeadsDetails/?dateFrom=${1}`)
        .then((res) => {
          if (res.status === 200) {
            const user = res.data?.data?.find((el) => el.id == store.UserId);
            setSalesOwnerSummary(user);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [store.UserId]);

  useEffect(() => {
    if (store.UserId && store.Role !== process.env.REACT_APP_ROLE_CLIENT) {
      performRequest("POST", `/attendance/getUserAttendance/`, {
        userId: store.UserId,
        date: getDateTime(new Date()),
      })
        .then((res) => {
          if (res.status === 201) {
            setLoginTime(res.data?.attendance?.time);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [store, loginState.userlog]);

  useEffect(() => {
    if (
      employee &&
      (store.Role === process.env.REACT_APP_ROLE_ADMIN ||
        store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
        store.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
        store.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
        store.Role === process.env.REACT_APP_ROLE_SALLE)
    ) {
      performRequest("GET", `/incentive/totalRevenueOfMonthByName/${employee}`)
        .then((res) => {
          if (res.status === 200) {
            if (
              res.data.totalRevenue &&
              typeof +res.data.totalRevenue === "number"
            ) {
              setRevenue(res.data?.totalRevenue?.toFixed(2));
            } else {
              setRevenue(res.data?.totalRevenue);
            }
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [employee]);

  // useEffect(() => {
  //   if (store.Role !== process.env.REACT_APP_ROLE_CLIENT) {
  //     performRequest("GET", `/tasks/getTaskManagementDashboard`)
  //       .then((res) => {
  //         if (res.status === 200) {
  //           // setTaskData(res.data.taskManagementData);
  //           // sortData(res.data.taskManagementData);
  //           // console.log("res.data",res.data);
  //           setTotalTask(res?.data?.taskManagementCount);
  //           setTotalCompleteTask(res?.data?.completedTaskCount);
  //         } else {
  //           Toast("error", "Error while getting Tasks Count!");
  //         }
  //       })
  //       .catch((err) => {
  //         CustomErrorResponse(err);
  //       })
  //       .finally(() => setLoading(false));
  //   }
  // }, [currentUser]);

  useEffect(() => {
    if (store.Role !== process.env.REACT_APP_ROLE_CLIENT) {
      dispatch(fetchTaskCounts());
    }
  }, [dispatch, store.Role]);

  const handelLogout = () => {
    dispatch(logout());
    navigate("/account-login");
  };
  const officeLogoutAttendance = () => {
    navigate("/logout-attendance");
  };
  const goToHome = () => {
    navigate("/");
  };

  return (
    <>
      <header className="navbar navbar-expand-lg d-print-none">
        <div className="container-xl">
          <a
            // class="btn"
            data-bs-toggle="offcanvas"
            href="#offcanvasStart"
            // role="button"
            aria-controls="offcanvasStart"
            className="d-block d-lg-none "
          >
            <span
              className="navbar-toggler-icon"
              style={{ fontSize: "20px", color: "black" }}
            ></span>
          </a>
          <div className="d-flex gap-3">
            <a
              // class="btn"
              data-bs-toggle="offcanvas"
              href="#offcanvasStart"
              // role="button"
              aria-controls="offcanvasStart"
              className="d-none d-lg-block"
            >
              <span
                className="navbar-toggler-icon mt-5 ms-2"
                style={{ fontSize: "20px", color: "black" }}
              ></span>
            </a>
            <h1 className="navbar-brand  d-none-navbar-horizontal pe-0 pe-md-3">
              <span className="cursor-pointer" onClick={goToHome}>
                {/* <img
                className="navbar-brand-image"
                src="https://www.kryzen.com/wp-content/uploads/2022/02/kryzen-logo-1.png"
                alt="Kryzen"
                style={{
                  width: "110px",
                  height: "50px",
                }}
              /> */}
                <h1 className="fs-large m-0 p-0">
                  <span className="text-primary">α</span>lpha
                </h1>
                <p className="fs-5 ps-6 m-0 text-success">by KRYZEN</p>
              </span>
            </h1>
          </div>

          <div className="navbar-nav flex-row order-md-last">
            <div className="nav-item me-1 d-none d-md-flex">
              <GoogleTranslate />
            </div>
            {salesOwnerSummary && (
              <div className="nav-item me-1 d-none d-md-flex">
                <span className="d-flex lh-1 text-reset p-0 cursor-pointer">
                  <div
                    className="d-xl-block px-2"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div className="nav-item dropdown">
                      <span
                        className="ps-2 small badge bg-green-lt"
                        data-bs-toggle="dropdown"
                        aria-label="Open user menu"
                      >
                        Lead Summary
                      </span>
                      <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <table className="dropdown-item">
                          <tbody className="fs-2 me-2">
                            <tr>
                              <td colSpan={3}>Calls</td>
                              <td colSpan={2}></td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.totalCalls}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Unique</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.uniqueCalls}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Ans</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge bg-green-lt">
                                  {salesOwnerSummary?.answered}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>FL Calls</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.followUpCalls}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Ph Call</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.totalCalls -
                                    salesOwnerSummary?.whatsappCalls}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>WA</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.whatsappCalls}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Quotes</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.quotations}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Leads</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge bg-green-lt">
                                  {salesOwnerSummary?.leadsCreated}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Duration</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.totalDuration}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>SI</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.siteInspections}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>FL taken</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge">
                                  {salesOwnerSummary?.completedFollowupsCount}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>Fl Pending</td>
                              <td colSpan={2}>:</td>
                              <td className="text-end">
                                <span className="badge bg-red-lt">
                                  {salesOwnerSummary?.pendingFollowupsCount}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}
            {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
              store.Role === process.env.REACT_APP_ROLE_ADMIN ||
              store.Role === process.env.REACT_APP_ROLE_SALLE ||
              store.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
              store.Role === process.env.REACT_APP_ROLE_SALES_MANAGER) && (
              <div className="nav-item me-1 d-none d-md-flex">
                <span className="d-flex lh-1 text-reset p-0 cursor-pointer">
                  <div
                    className="d-xl-block px-2"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div>
                      <span className="ps-2 small">
                        {store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN
                          ? "This Week Revenue"
                          : "This Week Revenue"}
                      </span>
                    </div>
                    <div
                      className={`ms-2 mt-1 text-center fs-4 fw-bolder ${
                        revenue < 200000 ? "text-danger" : "text-success"
                      }`}
                    >
                      {store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                      store.Role === process.env.REACT_APP_ROLE_ADMIN
                        ? `₹${revenue}`
                        : `₹${revenue}/45000`}
                    </div>
                  </div>
                </span>
              </div>
            )}

            {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
              <div className="nav-item me-1 d-none d-md-flex">
                <span className="d-flex lh-1 text-reset p-0 cursor-pointer">
                  <div
                    className="d-xl-block px-2"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div>
                      <span className="ps-2 small">Tasks Status</span>
                    </div>

                    <div
                      className={`ms-2 mt-1 text-center fs-4 fw-bolder ${
                        totalCompleteTask === totalTask
                          ? "text-success"
                          : "text-warning"
                      }`}
                    >
                      {totalCompleteTask}/{totalTask}
                    </div>
                  </div>
                </span>
              </div>
            )}

            {loginState?.isLoggedIn && loginState?.userlog && loginTime && (
              <div className="nav-item ms-0 me-2">
                <span className="d-flex lh-1 text-reset p-0 cursor-pointer">
                  <div
                    className="d-xl-block pe-2"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div>
                      <span className="ps-2">{loginTime}</span>
                    </div>
                    <div className="ms-2 mt-1 small text-muted">
                      <LoginTimeCounter loginTime={loginTime} />
                    </div>
                  </div>
                </span>
              </div>
            )}
            <div className="nav-item dropdown">
              <span
                className="nav-link d-flex lh-1 text-reset p-0 cursor-pointer"
                data-bs-toggle="dropdown"
                aria-label="Open user menu"
              >
                <span
                  className="avatar avatar-sm"
                  style={{
                    backgroundImage: store?.UserPhoto
                      ? `url(${store?.UserPhoto})`
                      : `url(https://i.pinimg.com/474x/0a/a8/58/0aa8581c2cb0aa948d63ce3ddad90c81.jpg)`,
                  }}
                ></span>
                <div className="d-none d-xl-block ps-2">
                  <div>{CamelCaseToFirstUpper(store?.Name)}</div>
                  <div className="mt-1 small text-muted">
                    {store?.Role === "client"
                      ? "Kryzen Farm Client"
                      : CamelCaseToFirstUpper(store?.Role)}
                  </div>
                </div>
              </span>
              <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                <a className="dropdown-item" href="/account-setting">
                  <FcEngineering className="fs-2 me-2" /> Account Settings
                </a>
                {loginState.isLoggedIn &&
                  loginState.user &&
                  loginState.userlog &&
                  loginState.userlog.firstLogin && (
                    <span
                      onClick={officeLogoutAttendance}
                      className="dropdown-item"
                    >
                      <FcSportsMode className="fs-2 me-2" /> Office Logout
                    </span>
                  )}
                <span onClick={handelLogout} className="dropdown-item">
                  <FcLock className="fs-2 me-2" /> System Logout
                </span>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderMenu;
